import * as React from 'react';
import clsx from 'clsx';

import { Button, ButtonProps } from '../Button';

import classes from './PrimaryButton.module.scss';

export type PrimaryButtonProps = Omit<ButtonProps, 'classNames'> & {
  className?: string;
};

// new-ui
export function PrimaryButton({ className, ...props }: PrimaryButtonProps) {
  return <Button classNames={{ ...classes, container: clsx(classes.container, className) }} {...props} />;
}
